// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2579":"6976b3d7","2582":"5db51299","3935":"53784661","4242":"bd9a5256","5431":"7c62a987","7403":"8551351e","7520":"6976b3d7","8462":"55f53076","8742":"7b8b1b52"}[chunkId] + ".chunk.css";
};